var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.documentTypes,"label":"Select Document Type","item-text":"label","item-value":"id","rules":[_vm.validateRequired],"dense":""},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }